"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValues = void 0;
/**
 * Object.values that actually preserves values as types.
 *
 * @param o - The object to get the values from
 * @returns The values of the object preserving type
 */
function getValues(o) {
    return Object.values(o);
}
exports.getValues = getValues;
//# sourceMappingURL=getValues.js.map